/* eslint-disable no-secrets/no-secrets */
/* eslint-disable max-len */
import React, { useEffect, useState, useCallback, useContext, useRef } from 'react';
import _ from 'lodash';
import appConfig from 'app-config';
import moment from 'moment';
import {ViewModelForm, useDataRefresh, ViewModelServiceContext} from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { useModal } from '@jutro/components';
import { MLProductCodeUtil, MLErrorMessageUtil } from 'ml-portals-util-js';
import { MLNotificationBlockUtil, MLWizardNavUtil } from 'ml-portals-util-react';
import { MLModalService } from 'ml-portals-services-react';
import { platformMessages, FormModalPopover } from 'ml-components-platform-react';
import { MLUWIssuesPanelComponent } from 'gw-capability-gateway-quoteandbind-common-react';
import { MLMultiLobsDataHolderService } from 'ml-services-common-react';
import { UserService } from 'gw-capability-gateway';
import { withRouter } from 'react-router-dom';
import HOTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/HOTrackEvent';
import PUMBTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PUMBTrackEvent';
import { ScrollToError } from '@jutro/legacy/wizard-next';
import priorMetPopupMessages from '../../popups/PriorMetSubmission/PriorMetSubmissionPopup.messages';
import priorMetPopup from '../../popups/PriorMetSubmission/PriorMetSubmissionPopup.metadata.json5';
import priorMetPopupStyles from '../../popups/PriorMetSubmission/PriorMetSubmissionPopup.module.scss';
import metadata from './QualificationPage.metadata.json5';
import messages from './QualificationPage.messages';
import {LoadSaveService} from "gw-capability-gateway-quoteandbind";
import styles from './QualificationPage.module.scss'

const occupancyQuestionCode = 'HOPPreQualOccupant';
const occTypes = {
    myself: 'HOPPreQualOccupantMyself',
    tenant: 'HOPPreQualOccupantTenant'
};

const questionsToShow = ['HOPOccupationType_Ext', 'HOPEducationLevel_ML'];

const warningKey = 'warningKey';
const dwellingOccupancyKey = [
    'HOPPreQualHomeCondoDwellingOccupancy_Ext',
    'HOPPreQualLandlordDwellingOccupancy_Ext',
];

const dwellingOccupancyCode = {
    HomeCondoVacant: 'HOPPreQualHomeCondoOccupancyVacant',
    LandlordVacant: 'HOPPreQualLandlordOccupancyVacant',
};

const offeringLLHLLC = {
    LandlordCondo: 'HOPPlatinumLandLordCondo_Ext',
    LandlordHome: 'HOPDF3PlatinumLandLordHome_Ext',
};

const animalBittenOrAttackedKey = 'HOPPreQualAnimalBittenOrAttacked_Ext'
const isDayCareSelected = 'HOPPreQualDaycareOnPremise_ML'

const getFirstExisting = (obj, keys) =>
    keys.reduce((acc, key) => (acc ?? _.get(obj, key)), undefined);

const isTruthyYes = (val) => {
    const code =
        val == null
            ? undefined
            : (typeof val === 'object' ? val?.code : String(val));

    if (code === true || code === 'true') return true;

    const s = String(code || '').toUpperCase();
    return s === 'YES';
};

const _filterQuestionSet = (qs) => {
    qs.answers = Object.keys(qs.answers)
        .filter((key) => questionsToShow.includes(key))
        .reduce((obj, key) => {
            obj[key] = qs.answers[key];
            return obj;
        }, {});
};

const QualificationPage = (props) => {
    const modalApi = useModal();
    const {
        wizardData: submissionVM,
        updateWizardData,
        goNext,
        currentStep,
        isSkipping,
        steps,
        changeNextSteps,
        history
    } = props;

    const { authHeader } = useAuthentication();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { refreshData } = useDataRefresh();
    const translator = useTranslator();

    const { onValidate, isComponentValid, initialValidation } = useValidation('QualificationPage');

    const [qualWarningsAck, setQualWarningsAck] = useState(false);
    const qualWarningsActiveRef = useRef(false);
    const offeringCode = _.get(submissionVM, 'lobData.homeowners.offerings.value[0].branchCode');
    const offeringName = _.get(submissionVM, 'lobData.homeowners.offerings.value[0].branchName');
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const quoteID = submissionVM.quoteID.value;
    const isGpa = appConfig.portalCode === 'GPA';
    const isQuoteAndBuy = appConfig.portalCode === 'QB';
    const isHomeowners = MLProductCodeUtil.isHomeOwners(submissionVM.baseData.productCode.value);
    const isHomeOwnersPartialTypeRental = MLProductCodeUtil.isHomeOwnersPartialTypeRental(submissionVM.lobData?.homeowners?.coverables?.coveragePartType_ML?.value?.code);
    const isCondo = MLProductCodeUtil.getCondoCode(submissionVM.baseData.productCode.value);
    const isPersonalUmbrella = MLProductCodeUtil.isPersonalUmbrella(submissionVM.baseData.productCode.value);
    const questionSetCode = isHomeowners ? 'HOPPreQual' : 'PUPPreQual_PUE';
    const preQualQuestionSetPath = `lobData.${isHomeowners ? 'homeowners' : 'personalUmbrella'}.preQualQuestionSets.value[0]`;

    // for PUP only
    const priorInsuranceQuestionSetPath = `lobData.${isHomeowners ? 'homeowners' : 'personalUmbrella'}.priorInsurance.value[0]`;
    const priorInsuranceQuestionSetData = _.get(submissionVM, priorInsuranceQuestionSetPath);
    const productCode = submissionVM.baseData.productCode.value;
    const hasHopRental = submissionVM.lobData.homeowners?.coverables?.coveragePartType_ML?.value?.code === MLProductCodeUtil.getRentalCode();
    const hasHopCondo = submissionVM.lobData.homeowners?.coverables?.coveragePartType_ML?.value?.code === MLProductCodeUtil.getCondoCode();
    const driversPath = 'lobData.personalUmbrella.coverables.vehicleOperators.children';
    const drivers = _.get(submissionVM, driversPath, []);
    const isGPA = appConfig.portalCode === 'GPA';

    const [showErrors, setShowErrors] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [showReturnToQuote, setShowReturnToQuote] = useState(false);
    const quoteStep = steps.find((step) => step.mlStepName === 'quoteDetails');
    const [canRequote, setCanRequote] = useState(false);
    const [isUWIssuesPanelVisible, setIsUWIssuesPanelVisible] = useState(false);
    const [blockingUwIssues, setBlockingUwIssues] = useState([]);
    const [disableNextButton, setDisableNextButton] = useState(false);
    const viewModelService = useContext(ViewModelServiceContext);

    const {nextStepVisited, canShowReturnToQuoteButton} = MLWizardNavUtil(props);

    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
    } = MLModalService();

    const {
        clearBlockAlerts,
        clearErrorAlerts,
        addErrorAlert,
        addWarningAlert
    } = MLNotificationBlockUtil();

    // Homeowners specific variables
    const [occupancyAnswer, setOccupancyAnswer] = useState(_.get(submissionVM, `lobData.homeowners.preQualQuestionSets.value[0].answers[${occupancyQuestionCode}]`));
    const [polType, setPolType] = useState(_.get(submissionVM, 'lobData.homeowners.coverables.coveragePartType_ML.value'));
    let returnToQuoteClicked = false;

    const pupModel = _.get(submissionVM, 'lobData.personalUmbrella');
    const QUOTED_SUBMISSIONS_KEY = 'quotedSubmissionNumbers';

    const initVehicleOperator = (vehicleOperatorVM) => {
        vehicleOperatorVM.contact.updated.value = true;

        if (vehicleOperatorVM.isPrimaryNamedInsured.value) {
            vehicleOperatorVM.isHasLossWithin5YearsRequired.value = true;
        } else {
            vehicleOperatorVM.isHasLossWithin5YearsRequired.value = false;
        }

        return vehicleOperatorVM;
    };

    const vehicleOperatorsVM = pupModel?.coverables?.vehicleOperators.filter((vehicleOperatorVM) => initVehicleOperator(vehicleOperatorVM)) ?? [];

    const updateSubmissionVM = useCallback(() => {
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);

    const getBasePath = useCallback((specificDriver) => {
        const driverIndex = drivers.indexOf(specificDriver);
        return `${driversPath}.${driverIndex}`;
    }, [drivers]);

    const computeQualificationWarningMessages = useCallback(
        (answers) => {
            const msgs = [];
            const occCode = getFirstExisting(answers, dwellingOccupancyKey);

            if (occCode === dwellingOccupancyCode.HomeCondoVacant) {
                msgs.push(translator(messages.vacantDwellingUWWarning));
            }

            if (occCode === dwellingOccupancyCode.LandlordVacant) {
                if (offeringCode === offeringLLHLLC.LandlordCondo) {
                    msgs.push(translator(messages.vacantDwellingUWWarningLandlordCondo));

                    const newBranchCode = 'HOPLandLordCondo_Ext';
                    const newBranchName = 'Landlord Condo (Comprehensive)';

                    _.set(submissionVM, 'lobData.homeowners.offerings.value[0].branchCode', newBranchCode ?? '');
                    _.set(submissionVM, 'lobData.homeowners.offerings.value[0].branchName', newBranchName ?? '');
                    _.set(submissionVM, 'baseData.offeringCode_ML.value', newBranchCode ?? '');

                    updateWizardData(submissionVM)
                } else if (offeringCode === offeringLLHLLC.LandlordHome) {

                    msgs.push(translator(messages.vacantDwellingUWWarningLandlordHome));

                    const newBranchCode = 'HOPDF3LandLordHome_Ext';
                    const newBranchName = 'Dwelling Fire Three (Comprehensive)';

                    _.set(submissionVM, 'lobData.homeowners.offerings.value[0].branchCode', newBranchCode ?? '');
                    _.set(submissionVM, 'lobData.homeowners.offerings.value[0].branchName', newBranchName ?? '');
                    _.set(submissionVM, 'baseData.offeringCode_ML.value', newBranchCode ?? '');

                    updateWizardData(submissionVM)
                } else {
                    _.set(submissionVM, 'lobData.homeowners.offerings.value[0].branchCode', offeringCode ?? '');
                    _.set(submissionVM, 'lobData.homeowners.offerings.value[0].branchName', offeringName ?? '');
                    _.set(submissionVM, 'baseData.offeringCode_ML.value', null);

                    updateWizardData(submissionVM)
                }
            }

            const dayCare = _.get(answers, isDayCareSelected);

            const animalVal = _.get(answers, animalBittenOrAttackedKey);
            if (isTruthyYes(animalVal)) {
                msgs.push(translator(messages.animalLiabilityExclusion));
            }
            if(isTruthyYes(dayCare) && !isHomeOwnersPartialTypeRental) {
                msgs.push(translator(messages.dayCareNotification))
            }

            return msgs;
        },
        []
    );

    const resetValues = async () => {
            const ppcValues = await LoadSaveService.callVeriskIntegration(
                    submissionVM.quoteID.value,
                    authHeader)
    
            const newSubmissionVM = viewModelService.clone(submissionVM);
    
            _.set(
                newSubmissionVM,
                'lobData.homeowners.coverables.constructionDetails_ML.hydrantWithin1000Feet.value',
                ppcValues?.hydrantWithin1000Feet
            );
    
            _.set(
                newSubmissionVM,
                'lobData.homeowners.coverables.constructionDetails_ML.fireDistrictName.value',
                ppcValues?.fireDistrictName
            );
            
            const hydrantValue = ppcValues?.hydrantWithin1000Feet;
            const fireDistrict = ppcValues?.fireDistrictName ?? '';
            const fireDistrictValues = ppcValues?.fireDistrictNames
    
            setSelectedHydrantValue(hydrantValue);
            setSelectedFireDistrictValue(fireDistrict);
            setFireDistrictValues(fireDistrictValues);
            setIsFireDistrictEditable(!fireDistrict && fireDistrictValues.length > 1);
            setIsRefreshButtonVisible(isRefreshBtnVisible());
            setIsHydrantEditable(!isHydrantValueDisabled());
            
    
            _.set(newSubmissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.hydrantWithin1000Feet.value', hydrantValue);
            _.set(newSubmissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.fireDistrictName.value', fireDistrict);
            _.set(newSubmissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.isFireDistrictNameEditable.value', !fireDistrict && fireDistrictValues.length > 1);
    
            updateWizardData(newSubmissionVM);
    
            refreshData();
    };

    const homeownerCoverablesVM = _.get(submissionVM, 'lobData.homeowners.coverables');
    const constructionDetailsVM = _.get(homeownerCoverablesVM, 'constructionDetails_ML');
    const hydrant1000FtValue = _.get(constructionDetailsVM, 'hydrantWithin1000Feet.value');
    const fireDistrictInitialValues = _.get(constructionDetailsVM, 'fireDistrictNames.value', []);
    const fireDistrictName = _.get(constructionDetailsVM, 'fireDistrictName.value', '');
    const addressMatch = _.get(constructionDetailsVM, 'matchUsing.value.code', undefined);
    const hasWaterSupply = _.get(constructionDetailsVM, 'waterSupply.value', undefined);
    const hasSplitPPC = _.get(constructionDetailsVM, 'splitPPC.value', undefined);
    const hasFireDistrictName = _.get(constructionDetailsVM, 'fireDistrictName.value', undefined);
    const [fireDistrictValues, setFireDistrictValues] = useState(fireDistrictInitialValues);

    const fireDistrictDropdownValues = fireDistrictValues.length > 1
        ? fireDistrictValues
        : fireDistrictName
            ? [fireDistrictName]
            : [];

    const isRefreshBtnVisible = () => {
        return addressMatch?.toLowerCase() === 'z' && fireDistrictName !== '';
    };

    const isHydrantValueDisabled = () => {
        const val1 = addressMatch?.toLowerCase() === 'a' && !_.isUndefined(hasSplitPPC) && !_.isUndefined(hasWaterSupply) && hasWaterSupply == '-';
        const val2 = addressMatch?.toLowerCase() === 'z' && !_.isUndefined(hasSplitPPC) && fireDistrictName !== '';

        return !(val1 || val2);
    };

    const [selectedHydrantValue, setSelectedHydrantValue] = useState(hydrant1000FtValue);
    const [isFireDistrictEditable, setIsFireDistrictEditable] = useState((!fireDistrictName || fireDistrictName == '') && fireDistrictValues.length > 1);
    const [isHydrantEditable, setIsHydrantEditable] = useState(!isHydrantValueDisabled());
    const [isRefreshButtonVisible, setIsRefreshButtonVisible] = useState(isRefreshBtnVisible());

    const [selectedFireDistrictValue, setSelectedFireDistrictValue] = useState(fireDistrictDropdownValues.find(item =>
        item.split(';')[0].trim() === fireDistrictName
    ) || (fireDistrictName ?? ''));

    const updatePPCFields = useCallback(async () => {
            const hasFireDistrictName = _.get(constructionDetailsVM, 'fireDistrictName.value', undefined);
            if (!isModernProduct || !isHomeOwnersPartialTypeRental) return;
            const key = `ppcIntegrationCalled_${submissionVM.quoteID.value}`
            if (sessionStorage.getItem(key)) {
                return;
            }
            sessionStorage.setItem(key, 'true');
            await LoadSaveService.callVeriskIntegration(submissionVM.quoteID.value, authHeader);
        }, [isModernProduct]);

    useEffect(() => {
            setIsRefreshButtonVisible(isRefreshBtnVisible());
            setIsHydrantEditable(!isHydrantValueDisabled())
        }, [constructionDetailsVM, fireDistrictName, isRefreshButtonVisible, selectedHydrantValue]);

    useEffect(() => {
        if(isModernProduct && isHomeOwnersPartialTypeRental){
            updatePPCFields();
        }

        if (!isHomeowners || isHomeOwnersPartialTypeRental || !isModernProduct) {
            return;
        }

        const qs = _.get(submissionVM, priorInsuranceQuestionSetPath);
        if (!qs || qs.code !== 'PriorInsuranceMultiLine_Ext') {
            return;
        }

        const providerKey = 'MultLineCurrentInsuranceProvider_Ext';

        const answersPath = `${priorInsuranceQuestionSetPath}.answers`;

        if (!currentStep?.submitted) {
            _.set(submissionVM, `${answersPath}.${providerKey}`, null);

            Object.keys(qs.answers || {}).forEach(key => {
                if (key !== providerKey) {
                    _.unset(submissionVM, `${answersPath}.${key}`);
                }
            });
        }
        _.set(submissionVM, `${priorInsuranceQuestionSetPath}.readOnlyAnswers_Ext`, []);

        updateWizardData(submissionVM);
    }, [currentStep?.submitted]); 

    const showQualificationWarnings = useCallback(
        ({
            answers,
            renderNow,
        }) => {
            const messageList = computeQualificationWarningMessages(answers);

            if (messageList.length === 0) {
                if (qualWarningsActiveRef.current) {
                    clearBlockAlerts(warningKey);
                }
                qualWarningsActiveRef.current = false;
                setQualWarningsAck(false);
                return { active: false };
            }

            if (!qualWarningsActiveRef.current) {
                setQualWarningsAck(false);
            }
            qualWarningsActiveRef.current = true;

            if (renderNow) {
                clearBlockAlerts(warningKey);
                const content = (
                    <div>
                        {messageList.map((m, idx) => (
                            <div key={idx}>{m}</div>
                        ))}
                    </div>
                );
                addWarningAlert(content, warningKey);
            }

            return { active: true };
        },
        [computeQualificationWarningMessages]
    );

    const isQuoted = (quoteNumber) => {
        if (!quoteNumber) return false;
        const list = JSON.parse(localStorage.getItem(QUOTED_SUBMISSIONS_KEY) || '[]');
        return list.includes(quoteNumber);
    };

    const generateLiabilityLossesOverride = useCallback(() => {
        const updateVehicleOperator = (value, path) => {
            _.set(submissionVM, path, value);
            updateSubmissionVM();
        };

        const overrides = vehicleOperatorsVM?.map((vehicleOperator, index) => {
            const obj = {
                [`liabilityLossContainer${index}`]: {
                    visible: vehicleOperator.isPrimaryNamedInsured.value === true
                }
            };
            if (vehicleOperator.isPrimaryNamedInsured.value === true) {
                obj.liabilityLossRadioButton = {
                    id: `liabilityLossRadioButton${index}`,
                    path: `${getBasePath(vehicleOperator)}.hasLossWithin5Years`,
                    value: _.get(vehicleOperator, 'hasLossWithin5Years.value'),
                    onValueChange: updateVehicleOperator
                }
            }
            return obj;
        });

        return Object.assign({}, ...overrides);
    }, [getBasePath, submissionVM, updateSubmissionVM, vehicleOperatorsVM]);

    useEffect(() => {
        const data = _.get(submissionVM, 'tempData.qualificationMessage');

        if (data != null) {
            addWarningAlert(data, 'submissionWarning');

            _.unset(submissionVM, 'tempData.qualificationMessage');

            updateWizardData(submissionVM);
        }
    }, []);

    const checkForQuestionUwIssues = useCallback(() => {
        if(isQuoteAndBuy){
            return false;
        }
        const uwIssues = submissionVM.errorsAndWarnings?.underwritingIssues?.value;
        if (uwIssues?.length > 0) {
            const questionCheckpointIssues = uwIssues.filter((issue) => {
                return issue.checkingSet_Ext === 'Question' && issue.currentBlockingPoint === 'BlocksQuote';
            });
            if (questionCheckpointIssues?.length > 0 && submissionVM?.hvqDiscrepancies_ML?.value === undefined) {
                setIsUWIssuesPanelVisible(true);
                setBlockingUwIssues(questionCheckpointIssues);
                setDisableNextButton(true);
                return true;
            }
            setDisableNextButton(false);
            return false;
        }
        return false;
    }, [submissionVM.errorsAndWarnings?.underwritingIssues?.value]);

    const updatePreQualQuestionSets = useCallback((update) => {
        const answers = _.find(update, (qs) => qs.code === questionSetCode);
        _.set(submissionVM, preQualQuestionSetPath, answers);
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData, questionSetCode, preQualQuestionSetPath]);

    const updateSubmission = useCallback(() => {
        const updatePromise = LoadSaveService.updateDraftSubmission(submissionVM.value, authHeader);
        showProgressDialog(platformMessages.updatingSubmission, updatePromise);
        updatePromise.then((sub) => {
            _.set(submissionVM, 'value', sub);
            updateWizardData(submissionVM);
        }, () => {
            const title = translator(messages.saveSubmissionErrorTitle);
            const message = translator(messages.saveSubmissionErrorMessage);
            showErrorModal(title, message);
        });
    }, [LoadSaveService, authHeader, showErrorModal, showProgressDialog, submissionVM, translator, updateWizardData]);

    const showPolicyTypeChangedAlert = useCallback(() => {
        clearBlockAlerts('policyTypeHasChanged');
        const msg = (
            <FormattedMessage
                {...messages.policyTypeChangedWarning}
                values={{
                    firstLine: (
                        <strong>{translator(messages.policyTypeChangedWarningFirstLine)}</strong>
                    ),
                    lineBreak: <br />,
                    secondLine: (
                        translator(messages.policyTypeChangedWarningSecondLine)
                    )
                }}
            />
        );
        addWarningAlert(msg, 'policyTypeHasChanged');
    }, [clearBlockAlerts, translator, addWarningAlert]);

    const setCanRequoteFlag = useCallback ( async() => {
        setCanRequote(showReturnToQuote && _.get(quoteStep, 'visited') !== true);
    }, [quoteStep, showReturnToQuote]);

    useEffect(() => {
        if (!isSkipping) {
            if (isGPA) {
                UserService.getCurrentUser(authHeader).then((user) => {
                    if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                        HOTrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'Qualification Page' }, !isGPA);}
                    if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                        PUMBTrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'Qualification Page' });}
                });
            } else {
                if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                    HOTrackEvent('Quote Step Reached', isSkipping, submissionVM, null, { step: 'Qualification Page' }, true);
                } else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                    PUMBTrackEvent('Quote Step Reached', isSkipping, submissionVM, null, { step: 'Qualification Page' }, true);
                }
            }
        }
        canShowReturnToQuoteButton(submissionVM, authHeader, quoteStep).then((response) => {
            setShowReturnToQuote(!!response);
        });
        checkForQuestionUwIssues();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setCanRequoteFlag();
    }, [setCanRequoteFlag, submissionVM]);

    const checkForDisableNextButton = useCallback((issues) => {
        if (issues?.length > 0) {
            const questionCheckpointIssues = issues.filter((issue) => {
                return issue.checkingSet_Ext === 'Question' && issue.currentBlockingPoint === 'BlocksQuote';
            });
            setDisableNextButton(questionCheckpointIssues?.length > 0);
        }
    }, []);

    const dwellingInfoQuestionSetData = _.get(submissionVM.lobData.homeowners, 'dwellingAdditionalInfo.value[0]');
    const filteredDwellingInfoQuestionSetData = _.clone(dwellingInfoQuestionSetData);
    if (filteredDwellingInfoQuestionSetData) {
        if (isModernProduct && isHomeowners) {
            filteredDwellingInfoQuestionSetData.answers = _.omit(
                filteredDwellingInfoQuestionSetData.answers,
                'HOPOccupationType_Ext'
            );
        }
        _filterQuestionSet(filteredDwellingInfoQuestionSetData);
    }

    const updateJobIfPolicyTypeChanged = useCallback(() => {
        const postalCode = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.primaryAddress.postalCode.value');
        const productCode = _.get(submissionVM, 'baseData.productCode.value');
        MLMultiLobsDataHolderService.updateJob(quoteID, productCode, postalCode, polType.code, isGpa && authHeader);
    }, [authHeader, isGpa, polType, quoteID, submissionVM]);

    const checkPolicyType = useCallback((occupancyType) => {
        let showMessage = false;
        let newPolicyType;

        switch (polType.code) {
            case MLProductCodeUtil.getDwellingCode(): {
                showMessage = occupancyType === occTypes.tenant;
                newPolicyType = { code: MLProductCodeUtil.getLandlordHome() };
                break;
            }
            case MLProductCodeUtil.getLandlordHome(): {
                showMessage = occupancyType === occTypes.myself;
                newPolicyType = { code: MLProductCodeUtil.getDwellingCode() };
                break;
            }
            case MLProductCodeUtil.getCondoCode(): {
                showMessage = occupancyType === occTypes.tenant;
                newPolicyType = { code: MLProductCodeUtil.getLandlordCondo() };
                break;
            }
            case MLProductCodeUtil.getLandlordCondo(): {
                showMessage = occupancyType === occTypes.myself;
                newPolicyType = { code: MLProductCodeUtil.getCondoCode() };
                break;
            }
            default:
                break;
        }


        if (showMessage) {
            setPolType(newPolicyType);
            _.set(submissionVM, 'lobData.homeowners.coverables.coveragePartType_ML.value', newPolicyType?.code ?? '');
            showPolicyTypeChangedAlert();
            updateJobIfPolicyTypeChanged();
        }
        updateSubmission();
    }, [polType, showPolicyTypeChangedAlert, submissionVM, updateJobIfPolicyTypeChanged, updateSubmission]);

    const syncPreQualQuestionSets = useCallback((questionSetAnswers) => {

        const tenatOccupancyAnswer =_.get(submissionVM, 'lobData.homeowners.preQualQuestionSets.value[0].answers.HOPPreQualOccupant');
        const isTenantSelected = tenatOccupancyAnswer === "HOPPreQualOccupantTenant";
        const offeringCode = _.get(submissionVM,'lobData.homeowners.offerings.value[0].branchCode');
        const isValuePlusCondo = offeringCode === "HOPGoodCondo_ML"
        const isInvalidLandlordCondo = hasHopCondo && isTenantSelected && !isValuePlusCondo
        // US1104862 - PE validation: Block Condo → Tenant for non–Value Plus. Executed on change since policy type/offering updates happen before validateData.
        if (isInvalidLandlordCondo) {
            const title = translator(messages.invalidLandlordOfferingErrorTitle);
            const message = translator(messages.invalidLandlordOffering);
            showErrorModal(title, message);
            return false;
        }

        setQualWarningsAck(false);
 
        if (isQuoteAndBuy && isTenantSelected && (isHomeowners || isCondo)) {
            const contactUsError = {
                customError: {
                    appErrorMessages: [
                    translator(messages.homeCondoTenant),
                    ],
                    contactUsMessage: messages.homeCondoTenantContent,
                    quoteID: _.get(submissionVM, 'quoteID.value'),
                    tenantSelected: messages.tenantOccupied
                },  
        };
    
        // This immediately exits wizard → Contact Us
        return Promise.reject(contactUsError);
    }

        if (isHomeowners) {
            const currentOccupancyAnswer = questionSetAnswers.answers[occupancyQuestionCode];

            if (occupancyAnswer !== currentOccupancyAnswer) {
                setOccupancyAnswer(currentOccupancyAnswer);
                checkPolicyType(currentOccupancyAnswer);
                return;
            }
        }
        setDisableNextButton(false);
        const syncPromise = LoadSaveService.syncQuestionSetML(quoteID, [questionSetAnswers], authHeader);
        showProgressDialog(platformMessages.syncingQuestions, syncPromise, true);
        syncPromise.then(
            (updatedQuestionSets) => {
                updatePreQualQuestionSets(updatedQuestionSets);
            }
        ).catch(error => {
            // US963263: Handle CDC Exceptions using Generic Error Handler
            hideProgressDialog();
            MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
        });
    }, [isHomeowners, isCondo, LoadSaveService, quoteID, authHeader, showProgressDialog, occupancyAnswer, checkPolicyType, updatePreQualQuestionSets, isQuoteAndBuy]);

    const handleQuestionValueChange = (value, path, questionType) => {
    const isPrimaryPolicyNumber = _.get(submissionVM , "lobData.homeowners.preQualQuestionSets.value[0].answers.HOPPreQualPrimaryResInsured_Ext")
 
    if (isPrimaryPolicyNumber) {
        _.set(submissionVM, path, value);
        updateWizardData(submissionVM);
        return;
    }
 
    syncPreQualQuestionSets(value);
    };

    const handleQuestionBlurChange = (value, path, questionType) => {
        const isPrimaryPolicyNumber = _.get(submissionVM, "lobData.homeowners.preQualQuestionSets.value[0].answers.HOPPreQualPrimaryResInsured_Ext");
        if (!isPrimaryPolicyNumber) {
            _.set(submissionVM, path, value);
            updateWizardData(submissionVM);
            return;
        }
        syncPreQualQuestionSets(value);
    };

    const syncPriorInsuranceQuestionSets = () => {
        setDisableNextButton(false);
        const syncPromise = LoadSaveService.syncQuestionSetML(quoteID, [priorInsuranceQuestionSetData], authHeader);
        showProgressDialog(platformMessages.syncingQuestions, syncPromise, true);
        syncPromise.then((updatedQuestionSets) => {
            const priorInsuranceQs = updatedQuestionSets.find((q) => q.code === 'PriorInsuranceMultiLine_Ext');
            _.set(submissionVM, priorInsuranceQuestionSetPath, priorInsuranceQs)
            if(isModernProduct && isHomeowners)
            {
                 _.set(submissionVM, `${priorInsuranceQuestionSetPath}.readOnlyAnswers_Ext`, [])
            }
            updateWizardData(submissionVM);
            refreshData();
        }).catch(error => {
            // US963263: Handle CDC Exceptions using Generic Error Handler
            hideProgressDialog();
            MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
        });
    };

    const syncDwellingInfoQuestionSets = (questionSetAnswers, questionSetPath) => {
        _.set(submissionVM, questionSetPath, questionSetAnswers);
        updateWizardData(submissionVM);
        setDisableNextButton(false);
        refreshData();
    };

    const OriginalEffectiveDate = useCallback(() => {
        const questionSet = _.get(submissionVM, priorInsuranceQuestionSetPath);
        const originalDate = _.get(questionSet, 'answers.MultiLineTenureEffDate_Ext');
        const originalDateMessage = translator(messages.OriginalEffectiveDate);
        const futureDateMessage = translator(messages.FutureEffectiveDate);
        clearErrorAlerts();
        if (!_.isUndefined(originalDate) && originalDate !== null) {
            const dateIsValid = moment(originalDate, "MM/YYYY", true).isValid();
            if (dateIsValid === true) {
                const [month, year] = originalDate.split('/');
                const convertMonthYearToActualDate = new Date(`${month}/01/${year}`);
                if (convertMonthYearToActualDate.getTime() > Date.now()) {
                    addErrorAlert(futureDateMessage);
                    return true;
                }
            } else {
                addErrorAlert(originalDateMessage);
                return true;
            }
        }
        return false;
    }, [addErrorAlert, clearErrorAlerts, submissionVM, translator]);

    const onPriorInsuranceQuestionValueChange_Ext = useCallback((questionSetAnswers, path, qsQuestionType) => {
        clearBlockAlerts('NoCarrierError');
        if (qsQuestionType !== 'String' &&  qsQuestionType !== 'Integer' && qsQuestionType !== 'Date') {
            syncPriorInsuranceQuestionSets();
        } else {
            _.set(submissionVM, priorInsuranceQuestionSetPath, questionSetAnswers);
            refreshData();
        }
        if(isModernProduct && isHomeowners && !isHomeOwnersPartialTypeRental)
        {
              _.set(submissionVM, `${priorInsuranceQuestionSetPath}.readOnlyAnswers_Ext`, []);
        }
        updateWizardData(submissionVM);
    }, [refreshData, submissionVM, syncPriorInsuranceQuestionSets, updateWizardData]);

    const handleOnBlur = useCallback((evt, inputObj, qsQuestionType, aQuestionSetAnswersValue) => {
        // check if progress dialog is causing the onBlur event and if so, do not trigger another sync call
        const isTargetModal = evt?.relatedTarget?.className?.indexOf('ml-modal-loading') > -1;
        if ((qsQuestionType === 'String' || qsQuestionType === 'Integer' || qsQuestionType === 'Date') && !isTargetModal) {
            syncPriorInsuranceQuestionSets();
            updateWizardData(submissionVM);
        }
    }, [submissionVM, syncPriorInsuranceQuestionSets, updateWizardData]);


    const checkReadOnlyAnswer = (key) => {
        if(key === 'HOPPreQualOccupant' && isQuoteAndBuy && (submissionVM.value.isQuoted() || isQuoted(submissionVM?.quoteID?.value) || !_.isEmpty(_.get(submissionVM, 'quoteData.paymentQuotes_ML.value')))) {
            return true;
        }

        return false;
    };

    const companyPolicyNumber = () => {
        let policyNumber = null;
        let flag = false

        clearBlockAlerts('PUPPriorInsuranaceError');

        if (MLProductCodeUtil.isPersonalUmbrella(productCode)) {
            policyNumber = _.get(submissionVM.value, 'lobData.personalUmbrella.priorInsurance[0].answers.MultiLinePolicyNumber_Ext');

            const message = translator(messages.CompanyPolicyNumber);

            if (!_.isUndefined(policyNumber) && policyNumber !== null) {
                if (policyNumber.length > 25 || !/^[a-zA-Z0-9]+$/.test(policyNumber)) {
                    flag = true
                    addErrorAlert(message,'PUPPriorInsuranaceError');
                }
            }
        }

        return flag
    };

    const writeValue = useCallback((value, path) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, path, value);
        updateWizardData(newSubmissionVM);
    }, [submissionVM, updateWizardData, viewModelService]);

    const goToNextStep = useCallback(async(calledFromPopUp = false) => {
        let nextStepName;
        const grpIndex = _.findIndex(
            steps,
            ({ path }) => path === '/affiliation'
        );
        if (returnToQuoteClicked) {
            showProgressDialog(platformMessages.saveSubmission, null, false, 0);
            const submissionData = await LoadSaveService.updateDraftSubmission(submissionVM.value, authHeader);
            writeValue(submissionData, 'value');
            _.set(submissionVM, 'value', submissionData);
            updateWizardData(submissionVM);

            const zip = _.get(submissionVM, 'baseData.policyAddress.postalCode.value').substring(0, 5);
            history.push('/quoteentry', {
                quoteID: submissionVM.quoteID.value,
                postalCode: zip,
                returnToQuoteFlag: 'true'
            });
            return false;
        } else if (grpIndex > -1) {
            const remainingSteps = _.slice(steps, grpIndex);
            changeNextSteps(remainingSteps);
            nextStepName = MLProductCodeUtil.isHomeOwners(productCode) ? 'hoGroupAssociations' : 'pupGroupAssociations';
        } else {
            if (submissionVM.isSubmitAgent.value && submissionVM.hvqQuoteID_ML && submissionVM.hvqQuoteID_ML.value) {
                nextStepName = MLProductCodeUtil.isHomeOwners(productCode) ? 'hoHVQPreFillDiscrepanciesCheck' : 'paHVQPreFillDiscrepanciesCheck';
            } else if (MLProductCodeUtil.isHomeOwners(productCode)) {
                const coverageType = _.get(submissionVM, 'lobData.homeowners.coverables.coveragePartType_ML.value.code', undefined);
                if (coverageType === 'hoprental') {
                    const index = _.findIndex(
                        steps,
                        ({ path }) => path === '/construction'
                    );
                    if (index > 0) {
                        const remainingSteps = _.slice(steps, index + 1);
                        changeNextSteps(remainingSteps);
                    }
                    nextStepName = 'hoRating';
                } else {
                    const index = _.findIndex(
                        steps,
                        ({ path }) => path === '/construction'
                    );
                    if (index > 0) {
                        const remainingSteps = _.slice(steps, index);
                        changeNextSteps(remainingSteps);
                    }
                    nextStepName = 'hoConstruction';
                }
            } else {
                const index = _.findIndex(
                    steps,
                    ({ path }) => path === '/underlying-policies'
                );
                console.log(index);
                if (index > 0) {
                    const remainingSteps = _.slice(steps, index);
                    changeNextSteps(remainingSteps);
                }
                nextStepName = 'pupUnderlyingPolicies';
            }
        }

        _.set(submissionVM, 'portalCurrentStep_ML.value', currentStep.mlStepName);
        showProgressDialog(platformMessages.saveSubmission);
        try {
            let canSkipSave = steps.some((step) => step.mlStepName === nextStepName && !!step.visited);

            if (!canSkipSave) {
                setIsUWIssuesPanelVisible(false);
                const res = await LoadSaveService.updateDraftSubmission(submissionVM.value, authHeader);
                submissionVM.value = res;
                updateWizardData(submissionVM);
                if (checkForQuestionUwIssues()) {
                    return false;
                }
            } else {
                if (checkForQuestionUwIssues()) {
                    return false;
                }
            }
        } catch (error) {
            // US963263: Handle CDC Exceptions using Generic Error Handler
            MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
            return false;
        } finally {
            hideProgressDialog();
        }
        MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, nextStepName, authHeader);

        if (!nextStepVisited() && !calledFromPopUp) {
            return submissionVM;
        }
        goNext();
        return false;
    }, [LoadSaveService, authHeader, changeNextSteps, checkForQuestionUwIssues, currentStep.mlStepName, goNext, hideProgressDialog, nextStepVisited, productCode, showErrorModal, showProgressDialog, steps, submissionVM, updateWizardData]);

    const isPriorInsuranceMetOrFarmers = useCallback(() => {
        const answer = _.get(priorInsuranceQuestionSetData, 'answers.MultLineCurrentInsuranceProvider_Ext');

        if (isModernProduct && isHomeowners && !isHomeOwnersPartialTypeRental) {
            return answer === 'MultLineCurrentInsuranceProviderFarmers_Ext' || answer === 'MultLineCurrentInsuranceProviderNoPriorInsurance_Ext';
        }

        return answer === 'MultLineCurrentInsuranceProviderFarmers_Ext' || answer === 'MultLineCurrentInsuranceProviderMetLifePropCas_Ext';
    }, [priorInsuranceQuestionSetData]);

    const showPriorMetSubmissionPopup = useCallback(() => {
        const disableButton = () => {
            return _.isUndefined(_.get(submissionVM, 'baseData.newPolicyReason_Ext.value', undefined));
        };

        const newPolicyReasonHelpTextMap = {
            insuring_same_location_diff_policy_form: translator(priorMetPopupMessages.sameLocationPriorMetTooltipContent)
        };

        const newPolicyReasonHelpTextTitleMap = {
            insuring_same_location_diff_policy_form: translator(priorMetPopupMessages.sameLocationPriorMetTooltipTitle)
        };

        const mapAvailableValues = (values) => {
            if (submissionVM.isSubmitAgent.value === true) {
                values = values.filter((reason) => reason.code !== 'purchase_direct');
            }

            return values.map((type) => {
                return {
                    code: type.code,
                    name: translator({
                        id: type.name,
                        defaultMessage: type.name
                    })
                };
            });
        };

        const overrides = {
            newPolicyReasonRadioButtons: {
                helpTextTitleMap: newPolicyReasonHelpTextTitleMap,
                helpTextMap: newPolicyReasonHelpTextMap,
                availableValues: mapAvailableValues(_.get(submissionVM, 'baseData.newPolicyReason_Ext.aspects.availableValues', [])),
                value: _.get(submissionVM, 'baseData.newPolicyReason_Ext.value')
            }
        };

        const componentProps = {
            title: translator(priorMetPopupMessages.priorMetPopupHeader),
            uiProps: priorMetPopup.pageContent,
            actionBtnLabel: platformMessages.mlContinue,
            viewModel: submissionVM.baseData,
            disableButton: disableButton,
            modalBodyStyles: priorMetPopupStyles,
            overrideProps: overrides,
            onSaveAction: ((baseDataVM) => {
                const newSubmissionVM = _.clone(submissionVM);
                _.set(newSubmissionVM, 'baseData', baseDataVM);
                updateWizardData(newSubmissionVM);
                goToNextStep(true);
                return true;
            }),
            showXCloseButton: false
        };
        if (!OriginalEffectiveDate()) {
            modalApi.showModal(
                <FormModalPopover {...componentProps} />
            );
        }
    }, [goToNextStep, submissionVM, translator, updateWizardData, OriginalEffectiveDate]);

    useEffect(() => {
        localStorage.setItem('quoteID', quoteID);
        localStorage.setItem('firstName', submissionVM.baseData.primaryNamedInsured_ML.firstName.value);
    }, [quoteID, submissionVM.baseData.primaryNamedInsured_ML.firstName.value]);

    const getWizardMessage = () => {
        let baseMsg;
        let boldMsg;
        const groupIndex = steps.findIndex((step) => step.path === '/affiliation');

        if (groupIndex > -1 && !MLProductCodeUtil.isPersonalAuto(productCode)) {
            baseMsg = messages.confirmEmployerAndAffiliations;
            boldMsg = messages.employerAndAffiliations;
        } else if (MLProductCodeUtil.isPersonalAuto(productCode)) {
            baseMsg = messages.baseWizardMessageNonRenters;
            boldMsg = messages.driversAndVehicles;
        } else if (MLProductCodeUtil.isHomeOwners(productCode) && !MLProductCodeUtil.isHomeOwnersPartialTypeRental(productCode)) {
            baseMsg = messages.baseWizardMessageNonRenters;
            boldMsg = messages.propertyDetails;
        } else if (MLProductCodeUtil.isHomeOwnersPartialTypeRental(productCode)) {
            baseMsg = messages.baseWizardMessageNonRenters;
            boldMsg = messages.discounts;
        } else if (MLProductCodeUtil.isPersonalUmbrella(productCode)) {
            baseMsg = messages.baseWizardMessageNonRenters;
            boldMsg = messages.policyInfo;
        }
        if (_.isUndefined(baseMsg) || _.isUndefined(boldMsg)) {
            return undefined;
        }
        return (
            <FormattedMessage
                {...baseMsg}
                values={{
                    boldText: (
                        <strong>{translator(boldMsg)}</strong>
                    )
                }}
            />
        );
    };

    const validateData = useCallback((isReturnToQuote = false) => {
        _.set(submissionVM, 'portalCurrentStep_ML.value', currentStep.mlStepName);

        if (!isComponentValid || !submissionVM.aspects.valid || !submissionVM.aspects.subtreeValid) {
            setShowErrors(true);
            setTimeout(()=>{
                setErrorTimestamp(errorTimestamp+1);
            }, 500);
            return false;
        }

        if(companyPolicyNumber()){
            return false
        }

        if (isModernProduct) {
            const answersAtSubmit =
                _.get(submissionVM, 'lobData.homeowners.preQualQuestionSets.value[0].answers', {}) || {};

            const { active: warningsActive } = showQualificationWarnings({
                answers: answersAtSubmit,
                renderNow: true,
            });

            if (warningsActive && !qualWarningsAck) {
                setQualWarningsAck(true);
                return false;
            }
        }


        if (!isHomeowners && isPriorInsuranceMetOrFarmers() && (!isReturnToQuote || _.isUndefined(_.get(submissionVM, 'baseData.newPolicyReason_Ext.value', undefined)))) {
            showPriorMetSubmissionPopup();
            return false;
        }

        if (isModernProduct && isHomeowners && isPriorInsuranceMetOrFarmers() && OriginalEffectiveDate()) {
            return false;
        }

        if (isReturnToQuote) {
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteDetails', authHeader);
        }

        return true;
    }, [authHeader, companyPolicyNumber,currentStep.mlStepName, errorTimestamp, isComponentValid, isHomeowners, isPriorInsuranceMetOrFarmers, showPriorMetSubmissionPopup, submissionVM]);

    useEffect(() =>{
        if (isQuoteAndBuy && !hasHopRental) {
            _.set(submissionVM, 'lobData.homeowners.preQualQuestionSets.value[0].answers.HOPPreQualOccupant', "HOPPreQualOccupantMyself");
            updateWizardData(submissionVM)
        }
    }, [])

    const onNext = useCallback(async () => {
        if (isGpa && !returnToQuoteClicked) {
            UserService.getCurrentUser(authHeader).then((user) => {
                if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                    HOTrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'Qualification Page', action: 'Qualification Page Submitted' });
                }
                if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                    PUMBTrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'Qualification Page', action: 'Qualification Page Submitted' });
                }
            });
        } else if (!isGPA) {
            if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                HOTrackEvent('Quote Step Submitted', false, submissionVM, null, { step: 'Qualification Page', action: 'Qualification Page Submitted' }, true);
            } else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                PUMBTrackEvent('Quote Step Submitted', false, submissionVM, null, { step: 'Qualification Page', action: 'Qualification Page Submitted' });
            }
        }

        const isDataValid = await validateData(returnToQuoteClicked);
        if (!isDataValid) {
            return false;
        }

        return goToNextStep();
    }, [authHeader, goToNextStep, isGpa, returnToQuoteClicked, submissionVM, validateData]);

    const onReturnToQuoteClicked = useCallback(() => {
        returnToQuoteClicked = true;
        onNext();
    }, [onNext]);

    const overrides = {
        gpaPageHeader: {
            visible: isGpa
        },
        pageContainer: {
            className: isGpa ? 'page-content-gpa' : undefined
        },
        priorInsuranceQuestionSet: {
            value: priorInsuranceQuestionSetData,
            onValueChange: onPriorInsuranceQuestionValueChange_Ext,
            onBlur: handleOnBlur,
            onValidate,
            showErrors,
            visible: !isHomeowners && !isPersonalUmbrella
        },
        preQualQuestionSet: {
            path: preQualQuestionSetPath,
            labelPosition: 'top',
            onValueChange: handleQuestionValueChange,
            onBlur: handleQuestionBlurChange,
            onValidate,
            showErrors,
            checkReadOnlyAnswer
        },
        dwellingQuestionSet: {
            path: 'lobData.homeowners.dwellingAdditionalInfo.value[0]',
            value: filteredDwellingInfoQuestionSetData,
            onValueChange: syncDwellingInfoQuestionSets,
            showHeaderML: false,
            onValidate,
            showErrors,
            visible: isHomeowners
        },
        qualificationPriorInsuranceQuestionSet: {
            path: priorInsuranceQuestionSetPath,
            onValueChange: onPriorInsuranceQuestionValueChange_Ext,
            onBlur: handleOnBlur,
            onValidate,
            showErrors,
            visible: false
        },
        nextDescription: {
            content: getWizardMessage()
        },
        returnToQuoteButton: {
            visible: showReturnToQuote,
            disabled: true
        },
        uwIssueContainer: {
            visible: isUWIssuesPanelVisible,
            uwIssues: blockingUwIssues,
            jobID: quoteID,
            publicID: _.get(submissionVM, 'value.publicID'),
            afterIssuesRefreshedCallback: checkForDisableNextButton,
            submissionVM,
            history
        },
        liabilityLossVehicleOpIterable: {
            data: vehicleOperatorsVM
        },
        ppcContainer: {
            visible: isModernProduct && isHomeOwnersPartialTypeRental && (!_.isUndefined(hasSplitPPC) || addressMatch?.toLowerCase() === 'z')
        },

        hydrantWithin1000ft: {
            disabled: !isHydrantEditable,
            value: selectedHydrantValue,
            visible: !_.isUndefined(hasSplitPPC),
            required: isHomeOwnersPartialTypeRental && isModernProduct,
            onValueChange: (value) => {
                _.set(
                    constructionDetailsVM,
                    'hydrantWithIn1000Feet.value',
                    value
                );
                setSelectedHydrantValue(value)
                setIsHydrantEditable(!isHydrantValueDisabled())
            }
        },

        fireDistrict: {
            disabled: !isFireDistrictEditable,
            value: fireDistrictDropdownValues.find(item => item.split(';')[0].trim() === fireDistrictName) || fireDistrictName,
            visible: addressMatch?.toLowerCase() === 'z',
            required: isHomeOwnersPartialTypeRental && isModernProduct,
            availableValues: fireDistrictDropdownValues.map(item => ({
                code: item,
                name: item,
            })),
            onValueChange: (selectedValue) => {
                setIsFireDistrictEditable(false);
                const selectedFireDistrict =
                    typeof selectedValue === 'string'
                        ? selectedValue
                        : selectedValue?.code || selectedValue?.value || '';

                _.set(
                    constructionDetailsVM,
                    'fireDistrictName.value',
                    selectedFireDistrict
                );
                _.set(
                    constructionDetailsVM,
                    'isFireDistrictNameEditable.value',
                    false
                );
            }
        },
        refreshButton: {
            visible: isRefreshButtonVisible,
            onClick: resetValues,
        },
        ...generateLiabilityLossesOverride()
    };

    const resolvers = {
        resolveCallbackMap: {
            onNext,
            resetValues
        },
        resolveComponentMap: {
            mluwissuespanelcomponent: MLUWIssuesPanelComponent
        }
    };

    const skipOnResumeIf = useCallback(async () => {
        const jumpToQuote = _.get(history, 'location.state.jumpToQuote', false)

        if (jumpToQuote) {
            return initialValidation().then((isValid) => !!isValid );
        } else {        
            if (!!_.get(submissionVM, 'bindData.policyNumber.value')
                && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
                return true;
            }

            if (MLMultiLobsDataHolderService.getLastVisitedStep() === currentStep.mlStepName) {
                return false;
            }

            if (isHomeowners && MLMultiLobsDataHolderService.getLastVisitedStep() === 'quoteDetails' &&
                submissionVM.hvqQuoteID_ML.value &&
                submissionVM.isBundle_ML.value) {
                return true;
            }

            if (_.get(submissionVM, `lobData.${isHomeowners ? 'homeowners' : 'personalUmbrella'}.preQualQuestionSets.value`)) {
                const answers = isHomeowners ? submissionVM.lobData.homeowners.preQualQuestionSets.value[0].answers : submissionVM.lobData.personalUmbrella.preQualQuestionSets.value[0].answers;
                const answerValues = _.values(answers);
                const isInitiallyValid = await initialValidation();
                if (!isInitiallyValid) {
                    return false;
                }
                const isHasLossWithin5YearsValid = _.get(submissionVM, "lobData.personalUmbrella.coverables.vehicleOperators.children[0].hasLossWithin5Years.aspects.valid", true);
                if (!isHasLossWithin5YearsValid) {
                    return false;
                }
                return answerValues.some((value) => value !== null);
            }

            if (isHomeowners) {
                return false;
            }

            return true;
        }
    }, [isComponentValid]);

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            skipWhen={skipOnResumeIf}
            showNext={!nextStepVisited()}
            disableNext={disableNextButton}
            onNext={onNext}
            nextLabel={translator(platformMessages.mlContinue)}
            showTextNextToButton={!nextStepVisited()}
            textNextToButton={getWizardMessage()}
            metadataPageId={!nextStepVisited() && _.get(metadata, 'pageContent.id')}
            showReturnToQuote={showReturnToQuote && canRequote}
            disableReturnToQuote={!canRequote || disableNextButton}
            onReturnToQuote={onReturnToQuoteClicked}
            updateWizardData={updateWizardData}
            validateData={validateData}
            history={history}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={styles}
                componentMap={resolvers.resolveComponentMap}
                model={submissionVM}
                showErrors={showErrors}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
};

QualificationPage.propTypes = wizardProps;
export default withRouter(QualificationPage);
